import { DataBean } from "../DataBean";

export class KpiConstantMeasurement extends DataBean {



    public async getKpiConstantMeasurementTypes(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getKpiConstantMeasurementTypes_Number", [id]);
    }

}
